import chair from './chair1.png'
import cobra from './cobra.jpg'
import dog from './dog1.png.png'
import tree from './tree1.png'
import warrior from './warrior2.png'
import traingle from './triangle.png'
import shoulderstand from './shoulderstand.jpg'

export const poseImages = {
    Tree: tree,
    Cobra: cobra,
    Dog: dog,
    Warrior: warrior,
    Chair: chair,
    Traingle: traingle,
    Shoulderstand: shoulderstand
}
